import { createRoutine } from 'redux-saga-routines';
import { ACTION_WEB_APP_REDIRECT } from '@/constants';

export default createRoutine(ACTION_WEB_APP_REDIRECT);
